export const CREATE_TOAST_EVENT = 'create-toast-event';
